/* RESPONSIBLE TEAM: team-fin-qa */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { ReactRoute } from 'embercom/lib/react-route';

class InboxReviewsIndexRoute extends Route {
  @service declare router: RouterService;

  beforeModel() {
    this.router.replaceWith('inbox.workspace.reviews.all');
  }
}

export default ReactRoute(InboxReviewsIndexRoute);
